import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { investmentHoldingsV2Selectors } from 'app-components/flux/investment-holdings-v2';
import { SECURITIES_REDUCER_KEY } from 'app-components/flux/securities/securitiesTypes';
import { getUnknownSecurity } from 'app-components/flux/securities/securitiesUtils';
import { Map as ImmutableMap } from 'immutable';
import { createSelector } from 'reselect';
import { INVESTMENT_QUOTES_V2_REDUCER_KEY } from './investmentQuotesV2Reducer';
import { getQuoteBySymbol } from './investmentQuotesV2Utils';

export const getResourceStore = (state) => state[INVESTMENT_QUOTES_V2_REDUCER_KEY];

export const getLoadPending = (state) => getResourceStore(state).loadPending;
export const getIsLoading = (state) => getResourceStore(state).isLoading;
export const getError = (state) => getResourceStore(state).error;
export const getResourcesById = (state) => getResourceStore(state).resourcesById;

export const getLastSyncDate = (state) => getResourceStore(state).lastSyncDate;

// NOTE: this is to break circular dependencies
const getSecuritiesResourcesById = (state) => state[SECURITIES_REDUCER_KEY]?.resourcesById;

export const getInvestmentQuoteBySymbol = createSelector(
  (state) => getResourcesById(state),
  (_state, symbol) => symbol,
  (quotes, symbol) => {
    return getQuoteBySymbol(quotes, symbol);
  },
);

export const getQuoteListByLocalSecurityId = createSelector(
  (state) => getSecuritiesResourcesById(state),
  (state) => getResourcesById(state),
  (securities, quotes) => {
    const fullList = securities.map((security) => {
      const symbol = security?.symbol || null;
      const quote = getQuoteBySymbol(quotes, symbol);
      return quote || security || getUnknownSecurity();
    });
    return ImmutableMap(fullList);
  },
);

export const getQuoteListByHoldingId = createSelector(
  (state) => getSecuritiesResourcesById(state),
  (state) => investmentHoldingsV2Selectors.getResourcesById(state),
  (state) => getResourcesById(state),
  (state) => featureFlagsSelectors.getFeatureFlag(state, 'relyOnSecurities'),
  (securities, holdings, quotes, securitiesFF) => {
    const fullList = holdings.map((holding) => {
      const security = securities?.get(holding?.localSecurityId);
      const symbol = securitiesFF ? security?.symbol || null : holding?.symbol || null;
      const quote = getQuoteBySymbol(quotes, symbol);
      if (!securitiesFF) {
        return quote || null;
      }
      return quote || security || getUnknownSecurity();
    });
    return ImmutableMap(fullList);
  },
);
